/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel selectors for the Feature Activation Framework.
 *
 * Views consume `selectIsFeatureEnabled(feature)` via `useUnitySelector` and
 * never reach `FeatureActivation` or `DeviceFeatures` directly.
 *
 * `isFeatureEnabled` is synchronous and reads device features that live
 * outside Redux. React-Redux re-runs this selector after every dispatch and
 * re-renders when the returned boolean changes, so when device features finish
 * loading (the `deviceFeaturesLoaded` dispatch that flips
 * `hasLoadedDeviceFeatures`) service-controlled features re-evaluate here.
 */

import { FeatureActivation } from "../../model/infrastructure";
import type { Feature } from "../../model/featureActivation";
import type { UnityRootState } from "../UnityAppStore";

export const selectIsFeatureEnabled =
  (feature: Feature) =>
  (_state: UnityRootState): boolean => {
    return FeatureActivation.getInstance().isFeatureEnabled(feature);
  };
